<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JR333M/images/9780802876768_cover.jpg?1684255543146" alt="This image is the cover for the book African American Readings of Paul"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">African American Readings of Paul
      </h1>
      <p class="bookDescription body article font2">
        <p>The letters of Paul—especially the verse in Ephesians directing slaves to obey their masters—played an enormous role in promoting slavery and justifying it as a Christian practice. Yet despite this reality African Americans throughout history still utilized Paul extensively in their own work to protest and resist oppression, responding to his theology and teachings in numerous—often starkly divergent and liberative—ways. </p><p>In the first book of its kind, Lisa Bowens takes a historical, theological, and biblical approach to explore interpretations of Paul within African American communities over the past few centuries. She surveys a wealth of primary sources from the early 1700s to the mid-twentieth century, including sermons, conversion stories, slave petitions, and autobiographies of ex-slaves, many of which introduce readers to previously unknown names in the history of New Testament interpretation. Along with their hermeneutical value, these texts also provide fresh documentation of Black religious life through wide swaths of American history. <i>African American Readings of Paul </i>promises to change the landscape of Pauline studies and fill an important gap in the rising field of reception history.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa M. Bowens, Emerson B. Powery, Beverly Roberts Gaventa
      </h2>
      
      <p class="authorDescription body article"><B>Lisa M. Bowens</B>&#160;is associate professor of New Testament at Princeton Theological Seminary. She is also the author of&#160;<I>An Apostle in Battle: Paul and Spiritual Warfare in 2 Corinthians 12:1-10</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?823ed5aa